import { Button } from '@/kit/Button';
import { Icon } from '@/kit/Icon';
import { Menu, useMenu } from '@/kit/Menu';

interface OptionMenuProps {
  title: string;
  disabled: boolean;
  options: { id: number; name: string }[];
  currentId: number;
  onSelect: (id: number) => void;
}

/** The edit-pencil button with its `mat-menu` of options; the current option is preceded by a check. */
export function OptionMenu({ title, disabled, options, currentId, onSelect }: OptionMenuProps) {
  const menu = useMenu();
  return (
    <>
      <Button title={title} disabled={disabled} onClick={menu.onOpen}>
        <Icon name="edit" outlined />
      </Button>
      <Menu {...menu} className="action-menu more-menu" xPosition="before">
        {options.map((option) => (
          <button
            key={option.id}
            type="button"
            role="menuitem"
            className="mat-mdc-menu-item mat-mdc-focus-indicator"
            onClick={() => onSelect(option.id)}
          >
            {currentId === option.id && <Icon name="check" />}
            <span className="mat-mdc-menu-item-text">{option.name}</span>
          </button>
        ))}
      </Menu>
    </>
  );
}
